import * as React from 'react';
import { Link } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
// import Link from '@mui/material/Link';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';

import bg from '../../images/bkg-fade.png';
import logo from '../../images/logo.png';

function Copyright() {
	return (
	  <Typography variant="body2" color="#D8D7D6" align="center">
		{'Copyright © BTECH, Inc. '}
		{new Date().getFullYear()}.
	  </Typography>
	);
}

const theme = createTheme({
	heroContainer: {
		backgroundImage: `url(${bg})`,
		backgroundPosition: "50%",
		backgroundRepeat: "no-repeat",
		backgroundSize: "cover",
	}
});

const buttonTheme = createTheme({
	palette: {
	  primary: {
		main: '#B1282E',
	  },
	}
  });

const StyledButton = styled(Button)`
  ${({ theme }) => `
	cursor: pointer;
	transition: ${theme.transitions.create(['background-color', 'transform'], {
		duration: theme.transitions.duration.standard,
	})};
	&:hover {
		transform: skew(-30deg);
	}
  `}
`;

export default function NotFound(props) {

  const { errorCode, errorName, description } = props;

  return (
	<ThemeProvider theme={theme}>
		<Box style={theme.heroContainer}>
	  <CssBaseline />
	  <AppBar
			color="primary"
			position="sticky"
			sx={{
				zIndex: (theme) => theme.zIndex.drawer + 1,
				background: 'linear-gradient(115deg, #0F1820 255px, #B1282E 300px)'
			}}
		>
			<Toolbar>
				<Grid container spacing={1} alignItems="center">
					<Grid item>
						<img src={logo} alt="BTECH, Inc." />
					</Grid>
				</Grid>
			</Toolbar>
		</AppBar>
		<Box style={{
			display: 'flex',
			height: `calc(100vh - 64px)`
		}}>
			<CssBaseline />
			<Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
				<Box component="main" sx={{ flex: 1, py: '15vh', px: 2 }}>
					<Container maxWidth="sm">
						<Typography
							variant="h1"
							fontSize="250px"
							fontFamily='Saira,sans-serif'
							fontWeight='600'
							align="center"
							color="#D8D7D6"
							// color="text.primary"
						>
							{ errorCode }
						</Typography>
						<Typography
							variant="h3"
							fontFamily='Saira,sans-serif'
							fontWeight='600'
							align="center"
							color="#D8D7D6"
							// color="text.primary"
							gutterBottom
						>
							{ errorName }
						</Typography>
						<Typography
							variant="h5"
							fontFamily='Saira,sans-serif'
							align="center"
							color="#D8D7D6"
							paragraph
						>
							{ description }
						</Typography>
						<Stack
							sx={{ pt: 4 }}
							direction="row"
							spacing={5}
							justifyContent="center"
						>
							<ThemeProvider theme={buttonTheme}>
								<Link color="inherit" to="/" style={{ textDecoration: "none" }}>
									<StyledButton variant="contained" sx={{ width: "180px"}} color="primary">
										<Typography variant="h6" fontFamily={ 'Saira,sans-serif' }>
											GO HOME
										</Typography>
									</StyledButton>
								</Link>
								<a href='https://www.btechinc.com/' style={{ textDecoration: "none" }}>
									<StyledButton variant="contained" sx={{ width: "180px" }} color="primary">
										<Typography variant="h6" fontFamily={ 'Saira,sans-serif' }>
											BTECH HOME
										</Typography>
									</StyledButton>
								</a>
							</ThemeProvider>
						</Stack>
					</Container>
				</Box>
				<Box component="footer" sx={{ p: 3, bgcolor: '#0F1820' }}>
					<Copyright />
				</Box>
			</Box>
		</Box>
		</Box>
	</ThemeProvider>
  );
}